// extracted by mini-css-extract-plugin
module.exports = {"error":"IndicatorDemo_error__6g1Q-"};